<template>
  <div id="app" class="app-content mb-4">
    <app-header></app-header>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <div class="amej-title">
            <h1>Merchant</h1>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
            <div v-if="message">
              <p v-if="message.length>0">{{message}}</p>
            </div>
          </b-alert>
          <div v-if="merchant.status=='accepted'">
            <h6>You are a merchant account holder</h6>
            <div class="qrcode pt-4" v-if="profile.author">
              <b-img :src="profile.author.qrcode" thumbnail alt="User QR Code"></b-img>
              <div class="pt-3">
                <b-button variant="outline-primary" @click="downloadQrcodeform">
                  <span class="material-icons">vertical_align_bottom</span> Download
                </b-button>
              </div>
            </div>
          </div>

          <div v-else-if="merchant.status=='requested'">
            <!-- <h3>Oopsss!!</h3> -->
            <h6>You have requested for a merchant account!.</h6>
          </div>

          <div v-else>
            <h3>Oopsss!!</h3>
            <h6>
              You are not a merchant yet! If you want to be a merchant, please click on this
              <a href="#" @click="merchantaccount">link</a>.
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import AppHeader from "../reuseable_components/Header.vue";

export default {
  name: "Merchant",
  components: {
    "app-header": AppHeader,
  },

  computed: {
    ...mapState([
      "message",
      "successmessage",
      "errormessage",
      "merchant",
      "profile",
      'kycdata',
      "downloadsuccess",
    ]),
  },

  created() {
    this.listMerchant();
    this.listProfile();
    this.listUserKyc();
  },
  data() {
    return {
      status: "",
      dismissSecs: 2,
      dismissCountDown: 0,
      showDismissibleAlert: false,
    };
  },
  mounted: function () {
    if (this.$store.state.token == "") {
      this.$router.replace("/");
    }
  },

  methods: {
    ...mapActions(["listMerchant", "listProfile", "listUserKyc"]),
    merchantaccount() {
      this.$store
        .dispatch("requestMerchantAccount", {
          status: "requested",
        })
        .then(() => {
          if (this.successmessage == "success") {
            location.reload();
          } else if (this.errormessage == "errormessage") {
            this.showDismissibleAlert = true;
            // this.$router.replace({name:"pay"});
          }
        });
    },
    downloadQrcodeform() {
      this.$store.dispatch("downloadQrcode", {});
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../css/style.scss';

.qrcode {
  button {
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}
</style>
